<ndt-phone-number-detail-view
   [phoneNumber]="phoneNumber$ | async"
   [phoneNumberPrivileges]="phoneNumberPrivileges$ | async"
   [callState]="callState$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [totalCount]="totalCount$ | async"
   [selectedAccountName]="selectedAccount$ | async"
   [isOnSystemPage]="isOnSystemPage$ | async"
   (formSaveCanceled)="onFormSaveCanceled()"
   (formSubmitted)="onFormSubmitted($event)"
   (numberReleased)="onNumberReleased($event)"
   (numberDeleted)="onNumberDeleted($event)"
   [idsFromRegister]="idsFromRegister$ | async"
   (navigateDown)="onNavigate($event)"
   (navigateUp)="onNavigate($event)"
   (loadIdPage)="onLoadIdPage()"
></ndt-phone-number-detail-view>
